module.exports = __webpack_public_path__ + "static/media/login.5509a6c3.png";